var getElementByDepth = function (property) {
    return function (count, element) {
        if (count <= 0)
            return element;
        var sibling = element[property];
        if (sibling === null)
            return element;
        if (!(sibling instanceof HTMLElement))
            return element;
        return getElementByDepth(property)(count - 1, sibling);
    };
};
export var getPreviousElementByDepth = getElementByDepth("previousElementSibling");
export var getNextElementByDepth = getElementByDepth("nextElementSibling");
